// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__n3PJr","title":"Info_title__1p5-O","selects":"Info_selects__13XLN","requiredAsterisk":"Info_requiredAsterisk__2qX0E"};